import "./AddStudentSkeleton.css";

/**
 * Skeleton loader for AddStudentPage.
 */
export const AddStudentSkeleton = () => {
  return (
    <div className="addStudentSkeleton">
      {/* ── UnlockBenefits skeleton ── */}
      <div className="addStudentSkeleton__benefits">
        {/* Title */}
        <div className="skel skel--title" />

        {/* 4 benefit items */}
        <div className="addStudentSkeleton__benefitsGrid">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="addStudentSkeleton__benefitItem">
              <div className="skel skel--circle" />
              <div className="addStudentSkeleton__benefitText">
                <div className="skel skel--textShort" />
                <div className="skel skel--textTiny" />
              </div>
            </div>
          ))}
        </div>

        {/* Note pill */}
        <div className="addStudentSkeleton__notePill">
          <div className="skel skel--pill" />
        </div>
      </div>

      {/* ── KidDetailsForm skeleton ── */}
      <div className="addStudentSkeleton__card">
        {/* Card header (blue bar) */}
        <div className="addStudentSkeleton__cardHeader">
          <div className="skel skel--headerText" />
          <div className="skel skel--headerPrice" />
        </div>

        {/* Card body – 3 rows of inputs */}
        <div className="addStudentSkeleton__cardBody">
          {/* Row 1: First Name / Last Name */}
          <div className="addStudentSkeleton__inputRow">
            <div className="skel skel--input" />
            <div className="skel skel--input" />
          </div>
          {/* Row 2: Username / Age */}
          <div className="addStudentSkeleton__inputRow">
            <div className="skel skel--input" />
            <div className="skel skel--input" />
          </div>
          {/* Row 3: Password (full width) */}
          <div className="addStudentSkeleton__inputRow">
            <div className="skel skel--input skel--inputFull" />
          </div>
        </div>
      </div>

      {/* ── Add Kid button skeleton ── */}
      <div className="addStudentSkeleton__addBtnWrap">
        <div className="skel skel--addBtn" />
      </div>

      {/* ── AssignProgress skeleton ── */}
      <div className="addStudentSkeleton__card">
        <div className="addStudentSkeleton__cardHeader">
          <div className="skel skel--headerText" />
        </div>
        <div className="addStudentSkeleton__cardBody">
          <div className="skel skel--descLine" />
          <div className="addStudentSkeleton__progressItem">
            <div className="skel skel--input skel--progressInput" />
          </div>
        </div>
      </div>

      {/* ── Continue to Pay button skeleton ── */}
      <div className="addStudentSkeleton__payBtnWrap">
        <div className="skel skel--payBtn" />
      </div>
    </div>
  );
};
